module.exports = __webpack_public_path__ + "img/meta-react-advanced.3a5f11a0.png";